module.exports = __webpack_public_path__ + "static/media/others.ff8e53b7.svg";